import axios from "axios";

export const historyApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/inventory`,
  headers: {
    "Content-Type": "application/json",
  },
});
